import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Landing } from './pages/Landing';
import { App as ConverterApp } from './pages/App';
import { Login } from './pages/Login';
import { Callback } from './pages/Callback';
import { ToastContainer } from './components/ui/Toast';
import { useToast } from './hooks/useToast';

function AppRouter() {
  const { toasts, removeToast } = useToast();

  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/app" element={<ConverterApp />} />
          <Route path="/login" element={<Login />} />
          <Route path="/callback" element={<Callback />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
      <ToastContainer toasts={toasts} onClose={removeToast} />
    </>
  );
}

export default AppRouter;